import { render, staticRenderFns } from "./stock_detail.vue?vue&type=template&id=4e74dd42&lang=pug&"
import script from "./stock_detail.vue?vue&type=script&lang=js&"
export * from "./stock_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports